<template>
  <div class="iqos-mode-toggle" :class="{
      [`${modeColor}-color`]: !!value,
      'v1-grey-6-color': !value
  }">
      <span class="qrw-heading-md bold"> {{ modeTitle }} </span>
      <BaseToggleSwitcher
        :value="value"
        @input="v => $emit('input', v)"
        :fillBg="value ? modeColor : 'v1-grey-6'"
        :fillCircle="value ? modeColor : 'v1-grey-6'"
        :disabledBg="'v1-grey-6'"
        v-if="!noBlackSwitcher"
      />
      <IQOSToggle :value="value"
        @input="v => $emit('input', v)" v-else/>
    </div>
</template>

<script>
export default {
    props: {
        value: Boolean,
        mode: {
            type: String,
            default: 'inside'
        },
        noColor: {
            type: Boolean,
            default: false
        },
        noBlackSwitcher: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modeTitle() {
            return {
                'inside': 'INSIDE',
                'preorder': 'TAKEAWAY',
                'delivery': 'DELIVERY',
                'reserve': 'RESERVE',
                'hotels': 'ROOMS',
                'preview': 'PREVIEW'
            }[this.mode];
        },
        modeColor() {
            if (this.noColor) return 'v1-grey-10';
            return {
                'inside': 'green-6',
                'preorder': 'yellow-4',
                'delivery': 'blue-4',
                'reserve': 'green-1',
                'hotels': 'v1-grey-10',
                'preview': 'v1-grey-10'
            }[this.mode];
        }
    }
}
</script>

<style scoped>
.iqos-mode-toggle {
    display: flex;
    width: 100%;
    justify-content: space-between;
}
</style>